<section>
    <div class="admin__menu">
        <ul>
            <li *ngFor="let item of menuItems"
                [ngClass]="{'menuSelected': isSelected(item.label), 'menuDeselected': !isSelected(item.label)}"
                (click)="selectMenuItem(item.label)" [style.display]="shouldShowMenuItem(item) ? 'flex' : 'none'">
                <span class="admin__menu-icon" [innerHTML]="getIcon(item.iconName, isSelected(item.label))"></span>
                <span class="admin__menu-text">{{ item.label }}</span>
            </li>
            <div *ngIf="isAdminMode">
                <div class="admin__divider"></div>
                <h1 class="admin__title">Admin</h1>
                <div class="expandable-menu"
                    [ngClass]="{'menuSelected': isMenuExpanded, 'menuDeselected': !isMenuExpanded}"
                    (click)="toggleMenu()">
                    <span class="expandable-menu-icon" [innerHTML]="getVehicleIcon()"></span>
                    <span class="expandable-menu-title">Vehicles</span>
                    <span class="chevron-icon" [innerHTML]="getChevronIcon()"></span>
                </div>
                <div
                    [ngClass]="isMenuExpanded ? 'expandable-menu-content expanded' : 'expandable-menu-content collapsed'">
                    <label *ngFor="let country of countries; trackBy: trackByCountry">
                        <input type="checkbox" [checked]="country.selected"
                            (change)="onCheckboxChange(country, $event)" />
                        {{ country.name }}
                    </label>
                </div>
                <!-- <li [ngClass]="{'menuSelected': isSelected('statistics'), 'menuDeselected': !isSelected('statistics')}"
                    (click)="selectMenuItem('statistics')">
                    <span class="admin__menu-icon" [innerHTML]="getStatisticsIcon()"></span>
                    <span class="admin__menu-text">Statistics</span>
                </li> -->
                <li [ngClass]="{'menuSelected': isSelected('Notifications'), 'menuDeselected': !isSelected('Notifications')}"
                    (click)="selectMenuItem('Notifications')">
                    <span class="admin__menu-icon" [innerHTML]="getNotificationsIcon()"></span>
                    <span class="admin__menu-text">Customer notifications</span>
                </li>
            </div>
            <div class="admin__divider"></div>
            <li (click)="logout()">
                <span class="admin__menu-icon" [innerHTML]="logoutIcon" alt="Logout Icon"></span>
                <span class="admin__menu-text">Log out</span>
            </li>
        </ul>
    </div>
</section>